import { RuleResult } from '../../../../types/DeclarationP5'

const C0601Validator = {
  validateModeOfTransportAtTheBorderRequirement: ({
    entryIndicator,
    security,
    additionalDeclarationType,
  }: {
    entryIndicator?: string
    security: string
    additionalDeclarationType: string
  }): RuleResult => {
    if (entryIndicator === 'true') {
      return 'REQUIRED'
    }

    return ['1', '2', '3'].includes(security) && additionalDeclarationType === 'A'
      ? 'REQUIRED'
      : 'OPTIONAL'
  },
}

export default C0601Validator
